import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AlertService} from 'maps-angular-components';
import {PageService} from '../shared/layout/services/page.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    title: 'home';
    form: FormGroup;
    formSubmitAttempt: boolean;
    headerFooter: boolean;
    pagination: number;
    dataItems: any;
    viewResults: boolean;
    textShow: string;

    constructor(
        private pageService: PageService,
        private alertService: AlertService,
    ) {
    }

    ngOnInit() {

        this.headerFooter = true;
        this.pageService.defineTitle('HOME');

    }


}
